import React, { useCallback, useContext, useEffect, useState } from "react";
import { genericPost } from "../../services/apiServices";
import { GET_DASHBOARD_TOP_PAYABLE } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { Box, Card, CardHeader, LinearProgress, Typography } from "@mui/material";
import { t } from "../../constants/translationHelper";
import CustomStatus from "../common/CustomStatus";

function LinearProgressWithLabel({ value }) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                border: "1px solid #0058CD",
                borderRadius: "8px",
                overflow: "hidden",
            }}
        >
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    height: 15,
                    backgroundColor: "#FFFFFF",
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: "#0058CD",
                    },
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontSize: "11px",
                        fontWeight: 600,
                        color: value > 50 ? "#FFFFFF" : "#0058CD",
                    }}
                >
                    {`${value.toFixed(2)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

const TopPayable = () => {
    const [topPayables, setTopPayables] = useState([]);
    const { token } = useContext(AuthContext);
    const fetchData = useCallback(async () => {
        try {
            const payload = { commanShipmentId: 0 };
            const response = await genericPost(GET_DASHBOARD_TOP_PAYABLE, payload);
            if (response.data.success && response.data.topPayables) {
                setTopPayables(response.data.topPayables);
            }
        } catch (error) {
            console.error("Error fetching Top Payables:", error);
        }
    }, []);
    const totalSum = topPayables.reduce(
        (sum, item) => sum + Number(item.totalAmount || 0),
        0
    );
    const highestBase = totalSum || 0;
    useEffect(() => {
        fetchData();
    }, [fetchData, token]);

    const headerStyle = {
        padding: "10px",
        borderBottom: "2px solid #ddd",
        fontSize: "12px",
        fontWeight: "700",
        color: "#000000",
    }

    return (
        <Card style={{
            padding: "0px", backgroundColor: "#FAEFEF80", boxShadow: "none", color: "#000000",
        }}>
            <CardHeader title={t("Top Payable")}
                titleTypographyProps={{
                    fontWeight: 700,
                    fontSize: "16px"
                }} />
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "left",
                }}
            >
                <thead>
                    <tr style={{ background: "#F8EBEBBF", }}>
                        <th style={headerStyle}   >
                            {t("Company Name")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Amount")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Share")}
                        </th>
                        <th style={headerStyle}   >
                            {t("Progress")}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {topPayables.length > 0 ? (
                        topPayables.map((row, index) => {
                            const percentage =
                                highestBase > 0
                                    ? (Number(row.totalAmount) * 100) / highestBase
                                    : 0;

                            const colorIndex = index % colorPlate.length;
                            const rowColor = colorPlate[colorIndex];
                            return (
                                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        <td style={{ padding: "5px", fontSize: "12px", }}>
                                            {row.clientCompany?.clientCompanyName}
                                        </td>
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        {row.baseCurrency?.currency_symbol}
                                        {parseFloat(row.totalAmount).toLocaleString()}
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", }}>
                                        <td style={{ padding: "0px" }}>
                                            {highestBase > 0
                                                ? ((Number(row.totalAmount) * 100) / highestBase).toFixed(2) + " %"
                                                : "0 %"}
                                        </td>
                                    </td>
                                    <td style={{ padding: "5px", fontSize: "12px", minWidth: "150px" }}>
                                        <LinearProgressWithLabel
                                            value={percentage}
                                        />
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" style={{ padding: "10px", textAlign: "center" }}>
                                {t("No data available")}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Card>
    );
};
export default TopPayable;

const colorPlate = [
    {
        colorId: 1,
        colorName: "Rose Blush",
        backgroundColor: "#FFD7E9",
        color: "#41001d"
    },
    {
        colorId: 2,
        colorName: "Lavender Mist",
        backgroundColor: "#f0ecff",
        color: "#0e0047"
    },
    {
        colorId: 3,
        colorName: "Ashwood Gray",
        backgroundColor: "#d4d0c4",
        color: "#464133"
    },
    {
        colorId: 4,
        colorName: "Olive Breeze",
        backgroundColor: "#D9DFC6",
        color: "#576237"
    },
    {
        colorId: 5,
        colorName: "Steel Teal",
        backgroundColor: "#dce5e8",
        color: "#253439"
    },
    {
        colorId: 6,
        colorName: "Dusty Rose",
        backgroundColor: "#F6D6D6",
        color: "#270909"
    },
    {
        colorId: 7,
        colorName: "Amethyst Haze",
        backgroundColor: "#ecdbf9",
        color: "#160523"
    },
    {
        colorId: 8,
        colorName: "Spring Leaf",
        backgroundColor: "#e9ffe3",
        color: "#0a2d00"
    },
    {
        colorId: 9,
        colorName: "Sky Sapphire",
        backgroundColor: "#C4D7FF",
        color: "#00143d"
    },
    {
        colorId: 10,
        colorName: "Mauve Shadow",
        backgroundColor: "#dcd3dc",
        color: "#120e13"
    }
];

